import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { MatLegacySnackBar as MatSnackBar } from '@angular/material/legacy-snack-bar';
import { ApiResult, ILookup } from 'src/app/shared/model/Index';
import { MatLegacyTableDataSource as MatTableDataSource } from '@angular/material/legacy-table';
import { MatSort } from '@angular/material/sort';
import { MatLegacyPaginator as MatPaginator } from '@angular/material/legacy-paginator';
import { Messages } from '@app/modules/compliance/constants/messages';
import { IStudent } from '@app/modules/compliance/model/student';
import { IPersonPhone } from '../../model/personphone';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { LookupService } from '@app/modules/maintenance/services/lookup.service';
import { PersonPhoneService } from '../../services/personphone.service';
import { ELookup } from '@app/modules/compliance/constants/eLookup';
import { emptyPersonPhone } from '@app/modules/compliance/constants/prepareEmptyObject';
import { Guid } from 'guid-typescript';
import { environment as env } from '@environments/environment'

@Component({
    selector: 'app-personphone',
    templateUrl: './person-phone.component.html',
    styleUrls:['./person-phone.component.css'],
})

export class PersonPhone implements OnInit {
    @Input() student: IStudent;
    @Input() WriteAction:boolean = false;
    isShown: boolean = false;
    isInternationlPhone: boolean = false;
    displayedColumns: string[] = ['phoneType', 'phone','ext'];
    dataSource = new MatTableDataSource<IPersonPhone>();
    @ViewChild(MatSort) sort: MatSort;
    @ViewChild(MatPaginator) paginator: MatPaginator;
    public phoneFormGroup: UntypedFormGroup;
    public personPhone: IPersonPhone = emptyPersonPhone();
    public phoneTypeList: ILookup[];
    constructor(
        private _formBuilder: UntypedFormBuilder,
        private _lookupservice: LookupService,
        private _snackBar: MatSnackBar,
        private _personPhoneservice: PersonPhoneService) { }
    ngOnInit() {
        this.getActiveLookups(ELookup.PhoneType);
        this.get();
    }
    cancel() {
        this.personPhone = emptyPersonPhone();
        this.fillForm(this.personPhone);
        this.isShown = false;
    }
    add() {
        this.personPhone = emptyPersonPhone();
        this.fillForm(this.personPhone);
        this.isShown = true;
    }
    edit(personPhone: IPersonPhone) {
        this.personPhone = personPhone;
        this.isShown = true;
        this.fillForm(this.personPhone);
    }
    delete(id: Guid) {
        this.deleteAddressById(id);
        this.cancel();
    }
    private getActiveLookups(tableName: string) {
        this._lookupservice.getActiveLookups(tableName).subscribe((result: ApiResult<ILookup[]>) => {
            if (result.validationErrors == null) {
                switch (tableName) {
                    case ELookup.PhoneType:
                        this.phoneTypeList = result.value;
                        break;
                    default:
                        break;
                }
            }
        }, error => console.error(error));
    }
    public get() {
        this._personPhoneservice.get(this.student.personId).subscribe((result: ApiResult<IPersonPhone[]>) => {
            if (result.validationErrors == null && result.value != null) {
                this.dataSource = new MatTableDataSource<IPersonPhone>(result.value);
                this.dataSource.paginator = this.paginator;
                this.dataSource.sort = this.sort;
            }
        }, error => console.error(error));
    }
    private deleteAddressById(id: Guid) {
        this._personPhoneservice.delete(id).subscribe((result: ApiResult<any>) => {
            if (result.validationErrors == null) {
                this.get()
            }
        }, error => console.error(error));
    }
    private fillForm(personPhone: IPersonPhone) {
        this.phoneFormGroup = this._formBuilder.group(
            {
                personId: [personPhone.personId],
                tenantId: [personPhone.tenantId],
                personPhoneId: [personPhone.personPhoneId],
                phoneTypeId: [personPhone.phoneTypeId],
                phone: [personPhone.phone],
                extension: [personPhone.extension],
                isInternational: [personPhone.isInternational],
            });
        this.isInternationlPhone = this.phoneFormGroup.get("isInternational").getRawValue();
    }
    public toggleChangeEvent(e){
        this.isInternationlPhone = e.checked;
        if(e.checked)
        {
            this.phoneFormGroup.get("isInternational").setValue(true);
        }
        else
        {
            this.phoneFormGroup.get("isInternational").setValue(false);
        }
    }
    public onSubmit() {
        this.personPhone = this.phoneFormGroup.value as IPersonPhone;
        if (this.personPhone.personPhoneId !== null) {
            this._personPhoneservice.put(this.personPhone).subscribe((result: ApiResult<number>) => {
                if (result.statusCode == 200) {
                    //this.cancel();
                    this.notify();
                    this.get();
                }
                else {
                    this.notifyWarnings(result.validationErrors);
                }
            }, error => console.error(error));
        }
        else {
            this.personPhone.personId = this.student.personId;
            this.personPhone.tenantId = Guid.parse(env.tenantId).toJSON().value;
            this.personPhone.personPhoneId = Guid.createEmpty().toJSON().value;
            this._personPhoneservice.post(this.personPhone).subscribe((result: ApiResult<number>) => {
                if (result.statusCode == 200) {
                    this.cancel();
                    this.notify();
                    this.get();
                }
                else {
                    this.personPhone.personPhoneId = null;
                    this.notifyWarnings(result.validationErrors);
                }
            }, error => console.error(error));
        }
    }
    notifyWarnings(message: string[]) {
        let snackBarRef = this._snackBar.open(message[0], "Close", {
            duration: 5000,
            panelClass: ['red-snackbar']
        });
        snackBarRef.afterDismissed().subscribe(() => {
        });
    }
    notify() {
        let snackBarRef = this._snackBar.open(Messages.PhoneSaved, "Close", {
            duration: 2000,
        });
        snackBarRef.afterDismissed().subscribe(() => {
        });
    }

    evalBind(data:ILookup,currentValue:number){
        if(data.id==currentValue){
            return true;
        }
      return !data.disabled;
    }
}
